import { render } from "./record.vue?vue&type=template&id=90c7ab12&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"

import "./record.vue?vue&type=style&index=0&id=90c7ab12&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-90c7ab12"

export default script